import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import type Rpc from "cc-frontend/services/rpc"

@tagName("")
export default class ConfirmLinkSharingBodyComponent extends Component {
  //args
  planbookId!: string
  goToLink!: Function
  goBack!: Function

  //services
  @service rpc!: Rpc

  //actions
  @action
  confirmButton() {
    this.rpc.planbook_collaboration_change_public_permission({
      planbookId: this.planbookId,
      role: "VIEWER",
    })
    this.goToLink()
  }

  @action
  cancelButton() {
    this.rpc.planbook_collaboration_change_public_permission({
      planbookId: this.planbookId,
      role: "NONE",
    })
    this.goBack()
  }
}
